import { ContentfulApi } from 'common/http';

import { toContentfulLandingPage } from './ContentfulLandingPagesServiceAdapters';
import { getContentfulLandingPageQuery } from './ContentfulLandingPagesServiceQueries';

import type { ContentfulLandingPageType, IContentfulLandingPageResponse } from 'types';

interface Params {
  type: ContentfulLandingPageType,
  slug: string,
  preview: boolean
}

export async function getContentfulLandingPage(params: Params) {
  const { type, slug, preview } = params;
  const query = getContentfulLandingPageQuery(type, slug, preview);
  const { data: { data } } = await ContentfulApi.fetch<{data: IContentfulLandingPageResponse}>(query, preview);
  return toContentfulLandingPage(type, data);
}
